module.exports = __webpack_public_path__ + "img/logo-text@2x.4fe6d994.png";